import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=2da50d10&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/modules/footer.scss?vue&type=style&index=0&id=2da50d10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da50d10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jin_macintosh/Documents/www.nosync/yusuugaku/web/public/wp-content/themes/ysk/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da50d10')) {
      api.createRecord('2da50d10', component.options)
    } else {
      api.reload('2da50d10', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=2da50d10&scoped=true&", function () {
      api.rerender('2da50d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/partials/Footer.vue"
export default component.exports